export default "__VITE_ASSET__24941fa7__"